// extracted by mini-css-extract-plugin
module.exports = {"toggle":"_0-jIt","container":"SA5AW","label":"T7+z2"};